import { render, staticRenderFns } from "./FuncModal.vue?vue&type=template&id=3bc815fb&scoped=true&"
import script from "./FuncModal.vue?vue&type=script&lang=ts&"
export * from "./FuncModal.vue?vue&type=script&lang=ts&"
import style0 from "./FuncModal.vue?vue&type=style&index=0&id=3bc815fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc815fb",
  null
  
)

export default component.exports